module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_5012.2ec44414.png";